
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Clock, Loader2, AlertCircle } from 'lucide-react';
import { WebSearchStatus } from '@/types/webSearch';

interface StatusBadgeProps {
  status: WebSearchStatus | null;
  queuePosition?: number | null;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status, queuePosition }) => {
  switch (status) {
    case 'pending':
      return (
        <Badge variant="outline" className="bg-yellow-100 text-yellow-800 border-yellow-200">
          <Clock className="h-3 w-3 mr-1" />
          Queued
          {typeof queuePosition === 'number' ? ` (#${queuePosition})` : null}
        </Badge>
      );
    case 'processing':
      return (
        <Badge variant="outline" className="bg-blue-100 text-blue-800 border-blue-200">
          <Loader2 className="h-3 w-3 mr-1 animate-spin" />
          Processing
        </Badge>
      );
    case 'completed':
      return (
        <Badge variant="outline" className="bg-green-100 text-green-800 border-green-200">
          <svg className="h-3 w-3 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
          Completed
        </Badge>
      );
    case 'failed':
      return (
        <Badge variant="outline" className="bg-red-100 text-red-800 border-red-200">
          <AlertCircle className="h-3 w-3 mr-1" />
          Failed
        </Badge>
      );
    case 'verification_needed':
      return (
        <Badge variant="outline" className="bg-blue-100 text-blue-800 border-blue-200">
          <AlertCircle className="h-3 w-3 mr-1" />
          Needs Verification
        </Badge>
      );
    case 'not_found':
      return (
        <Badge variant="outline" className="bg-gray-100 text-gray-600 border-gray-200">
          <AlertCircle className="h-3 w-3 mr-1" />
          Not Found
        </Badge>
      );
    default:
      return null;
  }
};
